<template>
  <transition name="fade">
    <div class="modal">
      <div class="modal__mask" @click="emitClose()"></div>

      <div class="modal__wrapper">
        <button v-if="hasCloseButton" class="modal__close-button" @click="emitClose()">
          <img :src="require('@/assets/img/icon/icon_close_24.svg')" alt="閉じる" />
        </button>

        <div class="modal__header">
          <slot name="header"></slot>
        </div>

        <div class="modal__content">
          <slot />
        </div>

        <div v-if="hasButtons" class="modal__buttons">
          <slot name="buttons"></slot>
        </div>

        <div v-if="hasLinks" class="modal__links">
          <slot name="links"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

/**
 * 共通 モーダルテンプレート
 */
export default defineComponent({
  name: 'CommonModalSection',
  props: {
    /**
     * モーダル内クローズボタンの有無
     */
    hasCloseButton: {
      type: Boolean,
      default: true,
    },
    /**
     * モーダル下部ボタンエリアの有無
     */
    hasButtons: {
      type: Boolean,
      default: true,
    },
    /**
     * モーダル下部リンクエリアの有無
     */
    hasLinks: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    emitClose(): void {
      /**
       * closeModal
       * 親コンポーネントへ閉じる処理を通知
       */
      this.$emit('close')
    },
  },
})
</script>

<style lang="scss">
.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 8px;
  transition: all ease 0.3s;
  z-index: 50;

  &.fade-enter-active,
  &.fade-leave-active {
    opacity: 1;
    pointer-events: auto;
  }

  &.fade-enter,
  &.fade-leave-to {
    opacity: 0;
    pointer-events: none;
  }

  &__mask {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 70%);
  }

  &__wrapper {
    position: relative;
    width: min(100%, 470px);
    max-height: calc(100vh - 116px);
    padding: 0;
    overflow-y: auto;
    background: $gray1;
    border-radius: 8px;
  }

  &__content {
    width: 100%;
    padding: 0 16px;
  }

  &__close-button {
    position: absolute;
    top: 4px;
    right: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    opacity: 0.5;
  }

  &__buttons {
    display: flex;
    flex-flow: row wrap;
    gap: 8px;
    margin: 20px 16px 16px;
  }

  &__links {
    @include fontSetTextMedium();

    font-weight: 700;
    letter-spacing: 0.04em;
    padding: 0 16px 16px;
    margin-top: 20px;
    margin-bottom: 16px;
  }

  &__fieldset {
    margin-top: 24px;
  }
}
</style>
